import { isApiErrorStatus } from '@sparklayer-io/spark-dash-core/types/errors';
import { useQuery } from '@tanstack/react-query';
import type { SyncErrorFilter, SyncLogIdentifier } from '../types';
import { useSyncApi } from './use-sync-api';

/**
 * The sync log's errors, narrowed by `filter` when given. A filtered sync log that doesn't
 * exist yet, as its data type has never synced, has no errors for the entity, so it's null
 * rather than an error.
 */
export const useSyncErrors = (identifier: SyncLogIdentifier, filter?: SyncErrorFilter) => {
  const { syncApi } = useSyncApi();

  return useQuery({
    queryKey: ['sync-status', identifier, 'errors', filter],
    queryFn: async () => {
      try {
        return await syncApi.logs().for(identifier).errors(filter);
      } catch (err) {
        if (filter && isApiErrorStatus(err, 404)) {
          return null;
        }
        throw err;
      }
    },
  });
};
